import {
  type AsyncStateObject,
  type Action,
  type SessionCoacheeDetails
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, SESSION_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<SessionCoacheeDetails> = {
  data: {
    totalCoachees: 0,
    sessionCompleted: 0,
    sessionNotStarted: 0,
    assessmentCompleted: 0
  },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const sessionCoacheeDetailsReducer = (
  state = INITIAL_STATE,
  action: Action<SessionCoacheeDetails>
): AsyncStateObject<SessionCoacheeDetails> => {
  switch (action.type) {
    case SESSION_ACTIONS.GET_SESSION_COACHEE_DETAILS + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case SESSION_ACTIONS.GET_SESSION_COACHEE_DETAILS + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case SESSION_ACTIONS.GET_SESSION_COACHEE_DETAILS + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: {
          totalCoachees: 0,
          sessionCompleted: 0,
          sessionNotStarted: 0,
          assessmentCompleted: 0
        },
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case SESSION_ACTIONS.GET_SESSION_COACHEE_DETAILS + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default sessionCoacheeDetailsReducer
